import { login, logout, expertLogin, expertLogout} from '@/apis/login'
import { 
    getToken, 
    setToken, 
    removeToken,
    getUserId, 
    setUserId, 
    setShowUsername,
    removeUserId,
    getIdentityType, 
    setIdentityType, 
    removeIdentityType 
} from '@/utils/auth'
import { resetRouter } from '@/router'
const getDefaultState = () => {
  return {
    token: getToken(),
    user_id: getUserId(),
    identity_type:getIdentityType(),
    name: '',
    avatar: '',
    userInfo:null,
    selectColumns:[]
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  setSelectColumns: (state, selectColumns)=>{
    state.selectColumns = selectColumns
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        let data = response.data
        if(data.status == "1"){
          
            let userinfo = data.data.user_info
            commit('SET_USERINFO', data.data.user_info)
            commit('SET_NAME', userinfo.user_name)
            setToken(userinfo.token)
            setUserId(userinfo.user_id)
            setShowUsername(userinfo.organization_name)
            setIdentityType(userinfo.identity_type)
            resolve()
        } else {
            reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  expertLogin({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      expertLogin({ username: username.trim(), password: password }).then(response => {
        let data = response.data
        if(data.status == "1"){
          
            let userinfo = data.data.user_info
            commit('SET_USERINFO', data.data.user_info)
            commit('SET_NAME', userinfo.user_name)
            setToken(userinfo.token)
            setUserId(userinfo.user_id)
            setShowUsername(userinfo.expert_real_name)
            setIdentityType(userinfo.identity_type)
            resolve()
        } else {
            reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          return reject('Verification failed, please Login again.')
        }

        const { name, avatar } = data

        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state}) {
    return new Promise((resolve, reject) => {
      logout().then(response => {
            let data = response.data
            if(data.status == "1"){
                removeToken()
                removeUserId()
                removeIdentityType()
                commit('SET_NAME', "")
                resolve()
            } else {
                reject(response)
            }
                
        }).catch(error => {
        reject(error)
        })
    })
  },

  expertLogout({ commit, state}) {
    return new Promise((resolve, reject) => {
      expertLogout().then(response => {
            let data = response.data
            if(data.status == "1"){
                removeToken()
                removeUserId()
                removeIdentityType()
                commit('SET_NAME', "")
                resolve()
            } else {
                reject(response)
            }
                
        }).catch(error => {
        reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js